/* istanbul ignore file */
import React from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { LoadConfigRender } from "features/app/components/LoadConfigRender";

const container = document.getElementById("root")!;
const root = createRoot(container);

if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_MOCK_API === "1"
) {
  const { worker } = require("./mock-server/browser");
  worker.start();
}

root.render(
  <React.StrictMode>
    <LoadConfigRender />
  </React.StrictMode>
);

reportWebVitals();
